import React, { useState, useEffect } from 'react';

const EditCustomer = ({ customerId, onClose }) => {
  const [customer, setCustomer] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getonecustomer.php?id=${customerId}`);
        const data = await response.json();
        setCustomer(data);
      } catch (error) {
        console.error('Error fetching customer details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerDetails();
  }, [customerId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer(prevCustomer => ({
      ...prevCustomer,
      [name]: value
    }));
  };

  const handleUpdate = async () => {
    try {
      const response = await fetch('https://app.mirzawaleed.com/updatecustomer.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({id: customerId, name: customer.name, location: customer.location, phone: customer.phone }),
      });

      const result = await response.json();
      if (result.success) {
      } else {
        console.log(result.message);
      }
    } catch (err) {
      console.error('Error adding customer:', err);

    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={modalStyle}>
      <h2>Edit Customer</h2>
      <form style={formStyle}>
        <div style={inputGroupStyle}>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            value={customer.name}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>
        <div style={inputGroupStyle}>
          <label>Location:</label>
          <select
            name="location"
            value={customer.location}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="Sarai">Sarai</option>
            <option value="Jhelum">Jhelum</option>
          </select>
        </div>
        <div style={inputGroupStyle}>
          <label>Phone:</label>
          <input
            type="text"
            name="phone"
            value={customer.phone}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>
        <button type="button" onClick={handleUpdate} style={updateButtonStyle}>Update</button>
      </form>
    </div>
  );
};

// Styles
const modalStyle = {
  width: '80%',
  maxWidth: '600px',
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  zIndex: 1000,
  overflow: 'auto'
};

const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  backgroundColor: 'transparent',
  border: 'none',
  fontSize: '20px',
  cursor: 'pointer'
};

const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px'
};

const inputGroupStyle = {
  display: 'flex',
  flexDirection: 'column'
};

const inputStyle = {
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #ccc'
};

const updateButtonStyle = {
  backgroundColor: '#4CAF50',
  color: '#fff',
  border: 'none',
  padding: '10px',
  borderRadius: '5px',
  cursor: 'pointer'
};

export default EditCustomer;
